import CitySEOHead from "@/components/feature/CitySEOHead";
import NaplesHeroSection from "./components/HeroSection";
import NaplesStickyNav from "./components/StickyNav";
import NaplesProcessingTimeSection from "./components/ProcessingTimeSection";
import NaplesServicesSection from "./components/ServicesSection";
import NaplesLocalAreaSection, { landmarks } from "./components/LocalAreaSection";
import NaplesTestimonialsSection from "./components/TestimonialsSection";
import NaplesAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import NaplesComparisonSection from "./components/ComparisonSection";
import NaplesMistakesSection from "./components/MistakesSection";
import NaplesHowItWorksSection from "./components/HowItWorksSection";
import NaplesFAQSection, { faqs } from "./components/FAQSection";
import NaplesHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import NaplesFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import NaplesTravelTimingSection from "./components/TravelTimingSection";
import NaplesDestinationsSection from "./components/DestinationsSection";

const pageTitle = "Emergency Passport Naples, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Naples, FL — as fast as 2–3 business days. A+ BBB rated, registered State Dept. courier serving Collier County, Marco Island, Bonita Springs, and Southwest Florida travelers, retirees, and seasonal residents needing urgent passport help.";

const areaServedList = [
  { "@type": "City", name: "Naples" },
  { "@type": "City", name: "Marco Island" },
  { "@type": "City", name: "Bonita Springs" },
  { "@type": "City", name: "Golden Gate" },
  { "@type": "City", name: "Naples Park" },
  { "@type": "City", name: "Immokalee" },
  { "@type": "City", name: "East Naples" },
  { "@type": "AdministrativeArea", name: "Collier County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Naples, Marco Island, Bonita Springs, and Collier County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function NaplesPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Naples"
        state="Florida"
        stateAbbr="FL"
        route="/cities/naples"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Naples, Florida"
        geoPosition="26.1420;-81.7948"
        keywords="expedited passport Naples, emergency passport Naples FL, same day passport Naples, fast passport Florida, passport renewal Naples, Collier County passport courier"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        hasPhysicalOffice
        lastModified="2026-06-09"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={landmarks}
      />
      <NaplesHeroSection />
      <NaplesStickyNav />
      <NaplesLocalAreaSection />
      <NaplesProcessingTimeSection />
      <NaplesServicesSection />
      <NaplesTravelTimingSection />
      <NaplesDestinationsSection />
      <NaplesTestimonialsSection />
      <NaplesAcceptanceFacilitiesSection />
      <NaplesComparisonSection />
      <NaplesMistakesSection />
      <NaplesHowItWorksSection />
      <NaplesFAQSection />
      <NaplesHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/naples" state="FL" />
      <NaplesFinalCTA />
    </div>
  );
}